import { jsx as _jsx } from "react/jsx-runtime";
var SVGLogout = function SVGLogout() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#777",
    strokeWidth: "2",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16 17l5-5-5-5M19.8 12H9M10 3H4v18h6"
    })
  });
};
export default SVGLogout;